// extracted by mini-css-extract-plugin
module.exports = {"count-pill":"CountPill-module__count-pill___3u4BJ","countPill":"CountPill-module__count-pill___3u4BJ"};